export const clothingType = ['t-shirt', 'chemise', 'tablier', 'veste'] as const
export type ClothingType = (typeof clothingType)[number]

export const clothingTypeLabel = {
  't-shirt': 'T-shirt',
  chemise: 'Chemise',
  tablier: 'Tablier',
  veste: 'Veste',
} as const

export const clothingSize = ['XS', 'S', 'M', 'L', 'XL', 'XXL'] as const
export type ClothingSize = (typeof clothingSize)[number]
